import { MAINTENANCE_MODE } from 'constants/features';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import { useSelector } from 'react-redux';
import { getRecipientId } from 'selectors/entities/recipient/recipient';

function useMaintenanceMode() {
  const { data: flags } = usePeertransferFlags([MAINTENANCE_MODE]);
  const recipientId = useSelector(getRecipientId);

  const isFeatureEnabled = !!flags?.[MAINTENANCE_MODE];

  return isFeatureEnabled && recipientId !== undefined && recipientId !== 'PTU';
}

export { useMaintenanceMode };
